module.exports = __webpack_public_path__ + "img/videoinit.aa529f10.svg";